<template>
  <div v-if="shouldShowZero" class="flex h-full items-center">
    <div
      class="bg-gray px-2 h-6 rounded text-sm text-center flex justify-center items-center w-20"
    >
      0
    </div>
  </div>

  <span
    v-else-if="displayPrice !== null"
    class="flex h-full gap-1 items-center"
  >
    <span class="flex items-center text-sm font-semibold">
      {{ formatCurrency(displayPrice) }}
    </span>
    <span class="flex items-center text-2xs">({{ availabilityLabel }})</span>
  </span>

  <p v-else-if="params.availability">-</p>
</template>

<script>
import { OfferObjectAvailability } from '@/api/v2/requests/offers';
import { formatCurrency } from '@/util/currency';

const AvailabilityPart = {
  ALL: 'all',
  FIRST_HALF: '1/2',
  SECOND_HALF: '2/2',
  NONE: '-',
};

export default {
  computed: {
    availability() {
      return this.params.availability?.local;
    },
    availabilityGlobal() {
      return this.params.availability?.global;
    },
    price() {
      return this.availability?.price;
    },
    isBothExternal() {
      return (
        this.availability?.isFirstHalfExternal &&
        this.availability?.isSecondHalfExternal
      );
    },
    isBothInContract() {
      return (
        this.availabilityGlobal?.firstHalfAvailability ===
          OfferObjectAvailability.IN_CONTRACT &&
        this.availabilityGlobal?.secondHalfAvailability ===
          OfferObjectAvailability.IN_CONTRACT
      );
    },
    shouldShowZero() {
      if (this.isBothExternal) return true;
      return !!(this.isBothInContract && !this.params.contract);
    },
    displayPrice() {
      if (!this.availability || this.shouldShowZero) return null;
      return this.price;
    },
    availabilityLabel() {
      const first = this.availability?.firstHalfAvailability;
      const second = this.availability?.secondHalfAvailability;

      const targetStatus = this.params.contract
        ? OfferObjectAvailability.IN_CONTRACT
        : OfferObjectAvailability.IN_OFFER;

      const isReservation =
        first === OfferObjectAvailability.IN_RESERVATION ||
        second === OfferObjectAvailability.IN_RESERVATION;

      const statusToCheck = isReservation
        ? OfferObjectAvailability.IN_RESERVATION
        : targetStatus;

      if (first === statusToCheck && second === statusToCheck) {
        return AvailabilityPart.ALL;
      }

      if (first === statusToCheck) {
        return AvailabilityPart.FIRST_HALF;
      }

      if (second === statusToCheck) {
        return AvailabilityPart.SECOND_HALF;
      }

      return AvailabilityPart.NONE;
    },
  },
  methods: {
    formatCurrency,
  },
};
</script>
